/**
 * created by yxy
 *  所有的操作按钮
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DialogBtn from "./DialogBtn";
import DialogButtonBtn1000 from "./DialogButtonBtn1000";
import OneBtn from './OneBtn'
import OneClickOpenFullButtonBtn from './OneClickOpenFullButtonBtn'
import TextBtn from "./TextBtn";
import request from "../../../../base/request";
import { message } from 'antd'
import OneClickBtn from "./OneClickBtn";

export default class Btn extends Component {
    static defaultProps = {
        btnList:[],
        refresh:()=>{

        }
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {

    }

    componentDidMount() {
    }

    render() {

        let  record=this.props.record;
        let Item=this.props.record;
        let roleCodes=window.top.currentUser.roleCodes;

        let role= "txy";

        let float=this.props.float||"";
        let customStyle={display: 'flex', };
        if(float=='float'){
            customStyle={
                float:'left'
            }
        }
        let {bigTabActiveKey,tabActiveKey }= this.props.currentState||{};
        let  reporterList=record&&record.reporterList||[];
        let reporterIds=[];
        reporterList.forEach(itemReport=>{
            reporterIds.push(itemReport.id);
        });


        return (
            <div style={{...customStyle, alignItems: "center"}}>
                {
                    this.props.btnList&&this.props.btnList.length&&this.props.btnList.map((btn, btnIndex) => {
                        let show = eval(btn.expression);
                        let temp;
                        if(btn.btnType === "dialogBtn"){

                            temp = <DialogBtn key={btnIndex} btn={btn} btnText={btn.text} okText={btn.okText} modalTitle={btn.modalTitle}  cancelText={btn.cancelText} record={record} refresh={()=>this.props.refresh()}/>
                        }else if(btn.btnType === "dialogButtonBtn1000"){
                            temp = <DialogButtonBtn1000 key={btnIndex} btn={btn} btnText={btn.text} okText={btn.okText} modalTitle={btn.modalTitle}  cancelText={btn.cancelText} record={record} refresh={(data)=>this.props.refresh(data)}/>
                        }else if(btn.btnType === "oneBtn"){
                            temp = <OneBtn key={btnIndex}  btn={btn}  btnText={btn.text} record={record}  />
                        }else if(btn.btnType === "oneClickOpenFullButtonBtn"){
                            temp = <OneClickOpenFullButtonBtn key={btnIndex} btn={btn} btnText={btn.text} record={record}  complete={()=>this.props.refresh()}/>
                        }else if(btn.btnType === "textBtn"){
                            temp = <TextBtn key={btnIndex}  btn={btn}  btnText={btn.text} record={record} btnClick={()=>{
                                this.btnClick(btn,record)
                            }} />
                        }else if(btn.btnType === "oneClickBtn"){
                            temp = <OneClickBtn key={btnIndex}  btn={btn}  btnText={btn.text} record={record} refresh={()=>this.props.refresh()} />

                        }
                        return show &&  (
                            temp
                        )
                    })
                }
            </div>
        )
    }


}